import styled from 'styled-components';
import { Flex, useBreakpointValue } from '@wegroup/design-system';
import BrokerCardContainer from '../../../common/components/finalization/BrokerCardContainer';
import AssistantQuestion from '@sales-conversation/src/components/flow/AssistantQuestion';
import ViewHeader from '@sales-conversation/src/components/legacy/question-view-header/QuestionViewHeader';

interface Props {
  error?: unknown;
}

const AdvisoryFlowFriendlyError = ({ error }: Props) => {
  const isMobile = useBreakpointValue({ base: true, laptop: false });

  return (
    <>
      {isMobile && <ViewHeader />}
      <Flex
        width="100%"
        height="100%"
        flexDir="column"
        background="white"
        overflowY="scroll"
        p={{ base: '3', tablet: '6' }}
        pb={{ base: '16', laptopL: '6' }}
      >
        <Flex maxW="4xl" flexDir="column" margin="0 auto">
          <StyledAssistantQuestion
            question={typeof error === 'string' ? error : ''}
          />
          <BrokerCardContainer />
        </Flex>
      </Flex>
    </>
  );
};

const StyledAssistantQuestion = styled(AssistantQuestion)`
  margin: 0;
  align-self: center;
  margin-bottom: 1.6rem;

  h2 {
    margin: 0;
  }

  & .AssistantQuestion_avatar {
    display: none;
  }
`;

export default AdvisoryFlowFriendlyError;
